import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { TextArea } from '@scp/ui-shared/components/form-fields';
import { RadioButton } from '@scp/ui-shared/components/switches';
import { useField } from '@scp/ui-shared/components/form';
import { ChildGroupWrapper } from '@scp/ui-shared/components/switches/SwitchGroupBaseOption';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
var ChildGroup = styled(ChildGroupWrapper)(_templateObject(), baselineToPx(2));
export var RadioButtonWithTextArea = function RadioButtonWithTextArea(_ref) {
  var placeholder = _ref.placeholder,
      name = _ref.name,
      label = _ref.label,
      optionValue = _ref.value,
      id = _ref.id,
      disabled = _ref.disabled,
      maxLength = _ref.maxLength;

  var _useField = useField("".concat(name, ".value")),
      _useField2 = _slicedToArray(_useField, 2),
      radioButtonField = _useField2[0],
      radioButtonMeta = _useField2[1];

  var _useField3 = useField("".concat(name, ".input")),
      _useField4 = _slicedToArray(_useField3, 3),
      textAreaField = _useField4[0],
      textAreaMeta = _useField4[1],
      textAreaHelpers = _useField4[2];

  var handleRadioButtonChange = function handleRadioButtonChange(e) {
    radioButtonField.onChange(e);
    textAreaHelpers.setValue('');
  };

  var isSelected = optionValue === (radioButtonField === null || radioButtonField === void 0 ? void 0 : radioButtonField.value);
  return React.createElement(React.Fragment, null, React.createElement(RadioButton, {
    id: id,
    name: radioButtonField.name,
    label: label,
    value: optionValue,
    checked: isSelected,
    onBlur: radioButtonField.onBlur,
    onChange: handleRadioButtonChange,
    invalid: !!radioButtonMeta.error && radioButtonMeta.touched,
    disabled: disabled
  }), isSelected && React.createElement(ChildGroup, {
    "$isCheckbox": true,
    "$leftOffset": 54
  }, React.createElement(TextArea, {
    id: textAreaField.name,
    name: textAreaField.name,
    placeholder: placeholder,
    value: textAreaField === null || textAreaField === void 0 ? void 0 : textAreaField.value,
    onBlur: textAreaField.onBlur,
    onChange: textAreaField.onChange,
    errorText: textAreaMeta.touched ? textAreaMeta.error : undefined,
    disabled: disabled,
    hiddenLabel: true,
    maxLength: maxLength,
    rows: 1,
    resize: true
  })));
};